// FILE: src/firebase.js

import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

/*
  👉 RECOMMENDED (for production):
  Move these values to environment variables.

  Example .env (Create React App):
    REACT_APP_FIREBASE_API_KEY=xxxx
    REACT_APP_FIREBASE_AUTH_DOMAIN=xxxx
    REACT_APP_FIREBASE_PROJECT_ID=xxxx
    REACT_APP_FIREBASE_STORAGE_BUCKET=xxxx
    REACT_APP_FIREBASE_MESSAGING_SENDER_ID=xxxx
    REACT_APP_FIREBASE_APP_ID=xxxx
*/

const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyDCBPbblI0vgMCSXmP4ojl1XU6wzoWnq7A",

  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "smart-church-cms.firebaseapp.com",

  projectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID ||
    "smart-church-cms",

  // ✅ CONFIRMED FROM YOUR CONSOLE
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "smart-church-cms.firebasestorage.app",

  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ||
    "284229728989",

  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:284229728989:web:6c3e86dcdf72525f557934",
};

// ✅ Prevent double initialization (important for hot reloads)
const app = !getApps().length
  ? initializeApp(firebaseConfig)
  : getApps()[0];

// ✅ Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;

/*
  🔧 TEMP DEBUG HELPERS
  Allows quick access in browser console:
    window.__FIREBASE_APP.auth
    window.__FIREBASE_APP.db
    window.__FIREBASE_APP.storage

  ❗ REMOVE before production
*/
if (typeof window !== "undefined") {
  try {
    window.__FIREBASE_APP = { auth, db, storage };
    window.__FIREBASE_DEBUG = true;
    console.info(
      "Firebase debug helpers enabled (remove before production)"
    );
  } catch (err) {
    console.warn("Firebase debug helpers failed to attach", err);
  }
}

/*
  ❌ Anonymous sign-in disabled
  It caused admin / permission issues earlier.
  Uncomment ONLY if you intentionally need it.
*/
// import { signInAnonymously } from "firebase/auth";
// signInAnonymously(auth)
//   .then(() => {
//     console.log("Signed in anonymously:", auth.currentUser?.uid);
//   })
//   .catch((err) => {
//     console.error("Anonymous sign-in failed:", err);
//   });
